import { Helmet } from "react-helmet";
import styles from "./style.module.scss";
import ContainerHeaderLayout from "views/components/ContainerHeaderLayout/ContainerHeaderLayout";
import TaskManagerTable from "./TaskManagerTable/TaskManagerTable";
import Loader from "views/uikit/Loader";
import { useUserConfig } from "hooks/useUserConfig";
import { GuideBook, GuideButton } from "views/components/Guide";
import { useTaskManagerGuideStore } from "views/components/Guide/guides/guideStores";
import { TASK_MANAGER_TOPICS } from "views/components/Guide/guides/pageGuides";

export default function TaskManagerPage() {
  const userConfig = useUserConfig();
  const isConfigLoading = userConfig.isLoading;
  const loading = userConfig.config.length === 0 || isConfigLoading;
  const guideOpen = useTaskManagerGuideStore((s) => s.open);
  const openGuide = useTaskManagerGuideStore((s) => s.openGuide);
  const closeGuide = useTaskManagerGuideStore((s) => s.closeGuide);

  return (
    <>
      <Helmet>
        <title>Task Manager</title>
      </Helmet>
      <ContainerHeaderLayout
        upperRow={
          <div className={styles.pageHeader}>
            Task Manager
            <GuideButton
              inTitle
              tooltip="How the Task Manager works"
              onClick={openGuide}
            />
          </div>
        }
      />
      <GuideBook
        open={guideOpen}
        onClose={closeGuide}
        heading="Task Manager"
        topics={TASK_MANAGER_TOPICS}
      />
      {loading ? (
        <div className={styles.loader}>
          <Loader />
        </div>
      ) : (
        <div className={styles.content}>
          <TaskManagerTable />
        </div>
      )}
    </>
  );
}
